module.exports = __webpack_public_path__ + "img/app-provisioning.11191a6e.svg";